<span class="far fa-file sq-icon-file-{{record.fileext}} fa-{{size}}x fa-fw" title="{{record.fileext}}"></span>